type TranslateFunction = (key: string, params?: Record<string, any>) => string;

export function getRelativeTimeString(date: string | Date, t: TranslateFunction): string {
  const now = new Date();
  const past = new Date(date);
  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  const intervals = {
    month: 31536000 / 12,
    day: 86400,
    hour: 3600,
    minute: 60
  };

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const diff = Math.floor(diffInSeconds / secondsInUnit);
    if (diff >= 1) {
      return t('trades.time.ago', { 
        time: t(`trades.time.${unit}${diff > 1 ? 's' : ''}`, { count: diff }) 
      });
    }
  }

  return t('trades.time.just_now');
} 